import { forwardRef } from "react";
import type { HTMLAttributes, ReactNode } from "react";

interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  action?: ReactNode;
}

const PageHeader = forwardRef<HTMLDivElement, PageHeaderProps>(
  ({ title, description, action, className = "", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`mb-8 ${className}`}
        style={{ fontFamily: "'Courier New', monospace" }}
        {...props}
      >
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          {/* Title and Description */}
          <div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-black text-white uppercase tracking-wide mb-2">
              {title}
            </h1>
            {description && (
              <p className="text-xs sm:text-sm text-gray-400 max-w-2xl leading-relaxed">
                {description}
              </p>
            )}
          </div>

          {/* Optional Action */}
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>

        {/* Bottom Border */}
        <div className="mt-6 border-b-2 border-white/10"></div>
      </div>
    );
  }
);

PageHeader.displayName = "PageHeader";

export default PageHeader;
